import { raiseToast } from '@fiverr-private/toast';

const showErrorToast = (message) => {
    raiseToast({
        message,
        type: 'error',
        location: 'top',
    });
};

export default showErrorToast;
